import { TranslocoPipe, provideTranslocoScope, translate } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { BottomSheetShell } from 'design-system';
import { CustomerNotificationItem } from '../../../interfaces/customer-notification.model';

type CustomersNotificationsBottomSheetData = {
  notifications: CustomerNotificationItem[];
};

@Component({
  providers: [provideTranslocoScope('customers')],
  selector: 'cus-customers-notifications-bottom-sheet',
  imports: [TranslocoPipe, BottomSheetShell, CommonModule, MatButtonModule],
  templateUrl: './customers-notifications-bottom-sheet.html',
  styleUrl: './customers-notifications-bottom-sheet.scss',
})
export class CustomersNotificationsBottomSheet {
  constructor(
    private bottomSheetRef: MatBottomSheetRef<CustomersNotificationsBottomSheet>,
    @Inject(MAT_BOTTOM_SHEET_DATA) readonly data: CustomersNotificationsBottomSheetData,
  ) {}

  onClose() {
    this.bottomSheetRef.dismiss();
  }

  getNotificationCardClass(severity: string) {
    const normalizedSeverity = severity?.toLowerCase?.() ?? '';

    switch (normalizedSeverity) {
      case 'danger':
      case 'error':
        return 'notification-card-danger';
      case 'warning':
      case 'warn':
      case 'alert':
        return 'notification-card-warning';
      case 'success':
        return 'notification-card-success';
      case 'info':
        return 'notification-card-info';
      default:
        return 'notification-card-default';
    }
  }

  getNotificationIconClass(severity: string) {
    const normalizedSeverity = severity?.toLowerCase?.() ?? '';

    switch (normalizedSeverity) {
      case 'danger':
      case 'error':
        return 'fa-solid fa-circle-exclamation';
      case 'success':
        return 'fa-solid fa-circle-check';
      case 'warning':
      case 'warn':
      case 'alert':
        return 'fa-solid fa-triangle-exclamation';
      case 'info':
        return 'fa-solid fa-circle-info';
      default:
        return 'fa-solid fa-circle-question';
    }
  }

  getNotificationIconColorClass(severity: string) {
    const normalizedSeverity = severity?.toLowerCase?.() ?? '';

    switch (normalizedSeverity) {
      case 'danger':
      case 'error':
        return 'notification-card-tone-danger';
      case 'success':
        return 'notification-card-tone-success';
      case 'warning':
      case 'warn':
      case 'alert':
        return 'notification-card-tone-warning';
      case 'info':
        return 'notification-card-tone-info';
      default:
        return 'notification-card-tone-default';
    }
  }

  getNotificationActionLabel(item: CustomerNotificationItem) {
    return item?.ToAction || translate<string>('customers.ui.pianificaVisita');
  }
}
